import { useState } from "react";
import {
  Box,
  Flex,
  VStack,
  Image,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
  Text,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
import logo from "../../assets/senca/logo.jpg";
import { Link } from "react-router-dom";
import authService from "../../routes/authService";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../components/Navbar/UserContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false); // Estado para o botão de loading
  const toast = useToast(); // Hook para notificações
  const navigate = useNavigate();
  const { refreshUserData } = useUser();

  // Cores adaptativas para modo claro/escuro
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const cardBgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const textColor = useColorModeValue("gray.700", "gray.200");
  const headingColor = useColorModeValue("red.600", "red.400"); // Cor do título

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true); // Ativa o estado de loading
    toast.closeAll(); // Fecha qualquer toast anterior

    try {
      const userData = await authService.login({ email, password });

      if (userData && userData.token) {
        await refreshUserData();
        toast({
          title: "Login bem-sucedido!",
          description: "Você foi logado com sucesso.",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right",
        });
        navigate("/home");
      } else {
        toast({
          title: "Erro de Login",
          description: "Não foi possível completar o login. Tente novamente.",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "top-right",
        });
      }
    } catch (err) {
      console.error("Erro no login:", err);
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Ocorreu um erro desconhecido. Por favor, tente mais tarde.";

      toast({
        title: "Erro de Autenticação",
        description: errorMessage,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    } finally {
      setLoading(false); // Desativa o estado de loading
    }
  };

  return (
    <Flex minH="100vh" align="center" justify="center" bg={bgColor} p={4}>
      <Box
        p={8}
        maxWidth="md"
        borderWidth={1}
        borderRadius="lg"
        boxShadow="xl"
        bg={cardBgColor}
        borderColor={borderColor}
        w="full"
      >
        <VStack spacing={6} align="stretch">
          {/* ALTERAÇÃO AQUI: Alinhando a imagem à esquerda */}
          <Image
            src={logo}
            alt="Logo"
            maxW="100px" // Para manter a proporção e evitar distorção
            h="auto" // Para manter a proporção
            alignSelf="flex-start" // Alinha a imagem à esquerda dentro do VStack
            ml={4} // Adiciona um pouco de margem à esquerda para afastá-la da borda
            mb={4}
          />
          <Heading as="h2" size="xl" textAlign="center" color={headingColor}>
            Login
          </Heading>

          <form onSubmit={handleSubmit}>
            <VStack spacing={4}>
              <FormControl id="email">
                <FormLabel color={textColor}>E-mail</FormLabel>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@senca.com.br"
                  required
                  size="lg"
                  borderRadius="md"
                  borderColor={borderColor}
                  _hover={{ borderColor: "gray.400" }}
                  _focus={{
                    borderColor: "red.500",
                    boxShadow: "0 0 0 1px red.500",
                  }}
                />
              </FormControl>

              <FormControl id="password">
                <FormLabel color={textColor}>Senha</FormLabel>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Sua senha"
                  required
                  size="lg"
                  borderRadius="md"
                  borderColor={borderColor}
                  _hover={{ borderColor: "gray.400" }}
                  _focus={{
                    borderColor: "red.500",
                    boxShadow: "0 0 0 1px red.500",
                  }}
                />
              </FormControl>

              <Button
                type="submit"
                colorScheme="red"
                size="lg"
                width="full"
                mt={4}
                isLoading={loading}
                loadingText="Entrando..."
              >
                Entrar
              </Button>

              <Text textAlign="center" fontSize="sm" color={textColor} mt={2}>
                <Link to="/">← Voltar ao site institucional</Link>
              </Text>
            </VStack>
          </form>
        </VStack>
      </Box>
    </Flex>
  );
}
